import * as React from "react";
import { ProgramClassItem } from "../../interfaces/program";
import IconBuilding from "../../components/icon/iconbuilding";
import IconPersonWorkspace from "../../components/icon/iconpersonworkspace";

interface ProgramClassFormatProps {
    programclass: ProgramClassItem;
}

const ProgramClassFormat = ({ programclass }: ProgramClassFormatProps) => {
    if (programclass.hasVirtual) {
        if (programclass.hasInPerson) {
            return (
                <>
                    <IconPersonWorkspace /> <span>Online &amp; In Person</span>
                </>
            );
        } else {
            return (
                <>
                    <IconPersonWorkspace /> <span>Online</span>
                </>
            );
        }
    } else if (programclass.hasInPerson) {
        return (
            <>
                <IconBuilding /> <span>In Person</span>
            </>
        );
    } else {
        // shouldn't happen!
        return (
            <>
                <IconBuilding /> <span>Unknown</span>
            </>
        );
    }
};

export default ProgramClassFormat;
